import { ChainId } from '@karak-network/uniswap-v2-sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.KARAK]: '0x48eB57918c60dcC03Fc25Cf6cdfbec710FCC66Dd'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
